// extracted by mini-css-extract-plugin
export default {"root":"styles_root__tpD8R","actionButtons":"styles_actionButtons__K6cr-","buttonDownload":"styles_buttonDownload__PgGmz","editAction":"styles_editAction__gbG89"};